export const SEASON_ERROR_MESSAGES = {
  SERVER_ERROR: 'An error occurred while retrieving seasons',
} as const;
